export const BACKTEST_METRIC_HELP = {
  runnableCases: 'Cases where we had enough member context to run a real replay prediction.',
  resolvedViaLinkedPerson: 'Cases resolved through a direct form_responses.linked_person_id match.',
  resolvedViaEmailFallback:
    'Cases resolved by matching form_responses.respondent_email to people.primary_email.',
  unresolvedCases:
    'Cases we could not resolve to a member onboarding response, so no replay run was executed.',
} as const;
